import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdatePrivateDiNumber = ({
  private_order_details_id,
  getData,
  rowId,
  setRowId,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const [company, setCompany] = useState([]);
  const [selectCompanyId, setSelectCompanyId] = useState("");
  const [productId, setProductId] = useState("");
  const [yardId, setYardID] = useState("");
  const [closingStockInYard, setClosingStockInYard] = useState("");
  const [singlePrivateDiNumber, setSinglePrivateDiNumber] = useState([]);
  const [initialYardIds, setInitialYardIds] = useState([]);
  const [initialCompanyIds, setInitialCompanyIds] = useState([]);
  const [initialProductNameIds, setInitialProductNameIds] = useState([]);
  const [orderNumbers, setOrderNumbers] = useState([
    { company_id: "", yard_id: "", product_name_id: "", order_qty: "" },
  ]);
  const [product, setProduct] = useState(Array(orderNumbers?.length).fill([]));
  const [yard, setYard] = useState(Array(orderNumbers?.length).fill([]));

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (rowId) {
      handleSinglePrivateDiNumber();
    }
  }, [rowId]);

  useEffect(() => {
    if (singlePrivateDiNumber) {
      const list = singlePrivateDiNumber?.order_details?.map((item) => ({
        yard_id: item.yard_id,
        yard_name: item.yard_name,
        company_id: item.company_id,
        company_name: item.company_name,
        location: item.location,
        product_name_id: item.product_name_id,
        product_name: item.product_name,
        inspection_qty: item.inspection_qty,
      }));
      setOrderNumbers(list);
      setInitialYardIds(
        singlePrivateDiNumber?.order_details?.map((item) => item.yard_id)
      );
      setInitialProductNameIds(
        singlePrivateDiNumber?.order_details?.map(
          (item) => item.product_name_id
        )
      );
      setInitialCompanyIds(
        singlePrivateDiNumber?.order_details?.map((item) => item.company_id)
      );
    }
  }, [singlePrivateDiNumber]);

  useEffect(() => {
    if (initialCompanyIds && initialCompanyIds?.length > 0) {
      const productLists = [];
      const yardLists = [];
      initialCompanyIds.forEach((companyId, index) => {
        const selectedCompany = company.find(
          (item) => item.id === parseInt(companyId)
        );
        if (selectedCompany) {
          const yards = selectedCompany.companyYard.map((yard) => ({
            id: yard.id,
            yard_name: yard.yard_name,
          }));
          yardLists[index] = yards;

          const products = selectedCompany.productName.map((product) => ({
            id: product.id,
            size: product.size,
          }));
          productLists[index] = products;
        }
      });
      setProduct(productLists);
      setYard(yardLists);
    }
  }, [initialCompanyIds]);

  const addOrderNumberRow = () => {
    setOrderNumbers([
      ...orderNumbers,
      { company_id: "", yard_id: "", product_name_id: "", order_qty: "" },
    ]);
    setSelectCompanyId(""); // Reset selectCompanyId to empty string
    setProductId(""); // Reset productId to empty string
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSinglePrivateDiNumber(() => {
      return {
        ...singlePrivateDiNumber,
        [name]: value,
      };
    });
  };

  const handleSinglePrivateDiNumber = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/private-order/single-private-di-number/${user_id}/${rowId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setSinglePrivateDiNumber(result.data);
    } else {
      setSinglePrivateDiNumber([]);
    }
  };

  const removeOrderNumberRow = (index) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers.splice(index, 1);
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleCompanyChange = (e, index) => {
    setSelectCompanyId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].company_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
    const selectedCompanyId = e.target.value;
    const selectedCompany = company.find(
      (item) => item.id === parseInt(selectedCompanyId)
    );
    if (selectedCompany) {
      const yards = selectedCompany.companyYard.map((yard) => ({
        id: yard.id,
        yard_name: yard.yard_name,
      }));
      const updatedYards = [...yard];
      updatedYards[index] = yards;
      setYard(updatedYards);
      const prodcts = selectedCompany.productName.map((product) => ({
        id: product.id,
        size: product.size,
      }));
      const updatedProducts = [...product];
      updatedProducts[index] = prodcts;
      setProduct(updatedProducts);
    }
  };

  // const getSingleYardDetailClosing = async () => {
  //   const BASE_URL = `${SERVER_URL}/api/yard-details/single-yard-details/${user_id}?company_id=${selectCompanyId}&product_name_id=${productId}&yard_id=${yardId}`;
  //   const res = await fetch(BASE_URL, {
  //     method: "GET",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //   });
  //   const result = await res.json();
  //   if (res.ok) {
  //     setClosingStockInYard(result.data);
  //   } else {
  //     setClosingStockInYard("");
  //   }
  // };

  // useEffect(() => {
  //   if (yardId) {
  //     getSingleYardDetailClosing();
  //   }
  // }, [yardId, productId, selectCompanyId]);

  const handleProductChange = (e, index) => {
    setProductId(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].product_name_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleYardChange = (e, index) => {
    setYardID(e.target.value);
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].yard_id = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleQtyChange = (e, index) => {
    const updatedOrderNumbers = [...orderNumbers];
    updatedOrderNumbers[index].inspection_qty = e.target.value;
    setOrderNumbers(updatedOrderNumbers);
  };

  const handleSave = (e) => {
    e.preventDefault();
  };
  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      id,
      di_number,
      di_date,
      payment_status,
      total_inspection_qty,
      di_qty,
      last_date_di,
    } = singlePrivateDiNumber;
    let BASE_URL =
      SERVER_URL + `/api/private-order/private-di-number/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        private_order_details_id: private_order_details_id,
        di_number,
        payment_status,
        di_date,
        last_date_di,
        // order_details: orderNumbers,
        total_inspection_qty,
        di_qty,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  function resetFields() {
    setSinglePrivateDiNumber({
      di_number: "",
      di_date: "",
      payment_status: "",
      total_inspection_qty: "",
      last_date_di: "",
      di_qty: "",
      last_date_di: "",
    });
    setProduct([]);
    setYardID("");
    setRowId("");
    setSelectCompanyId("");
    setClosingStockInYard("");
    setProductId("");
    setOrderNumbers([
      { company_id: "", yard_id: "", product_name_id: "", order_qty: "" },
    ]);
  }
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateDiNumber"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update TKCS Number Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div> */}
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                      //   ref={formRef}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="order">Di Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="order_number"
                                id="order"
                                placeholder="Di Number"
                                readOnly
                                onChange={handleChange}
                                value={singlePrivateDiNumber.di_number}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="di">Total Inspection Qty</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="total_inspection_qty"
                                id="total_inspection_qty"
                                placeholder="Total Inspection Qty"
                                onChange={handleChange}
                                required
                                value={
                                  singlePrivateDiNumber.total_inspection_qty
                                }
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="di">Di Qty</label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="di_qty"
                                id="di_qty"
                                placeholder="Di Qty"
                                onChange={handleChange}
                                value={singlePrivateDiNumber.di_qty}
                                required
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="di_date">Di Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="di_date"
                                id="di_date"
                                placeholder="Di Date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={singlePrivateDiNumber.di_date}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="last_date">Last Date Of DI</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="last_date_di"
                                id="last_date"
                                placeholder="Last Date Of DI"
                                // max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={singlePrivateDiNumber.last_date_di}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="payment_status">Remark</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="payment_status"
                                id="payment_status"
                                placeholder="Payment Status"
                                onChange={handleChange}
                                value={singlePrivateDiNumber.Remark}
                                autoComplete="off"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* {singlePrivateDiNumber?.order_details?.length > 0 &&
                        orderNumbers?.map((order, index) => {
                          const isInitialYardId =
                            order.yard_id &&
                            initialYardIds.includes(order.yard_id);
                          const isInitialCompanyId =
                            order.company_id &&
                            initialCompanyIds.includes(order.company_id);
                          const isInitialProductNameId =
                            order.product_name_id &&
                            initialProductNameIds.includes(
                              order.product_name_id
                            );
                          return (
                            <div key={index} className="row">
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="Company">Company Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.company_id}
                                    disabled={isInitialCompanyId}
                                    onChange={(e) =>
                                      handleCompanyChange(e, index)
                                    }
                                    id="Company"
                                  >
                                    <option value="">Select Company</option>
                                    {company &&
                                      company?.length > 0 &&
                                      company.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.company_name}, ${item.location}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="product">Product Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.product_name_id}
                                    onChange={(e) =>
                                      handleProductChange(e, index)
                                    }
                                    disabled={
                                      !selectCompanyId || isInitialProductNameId
                                    }
                                  >
                                    <option value="">Select Product</option>
                                    {product &&
                                      product[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.size}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="yard">Yard Name</label>
                                  <select
                                    className="form-control form-control-lg"
                                    value={order.yard_id}
                                    onChange={(e) => handleYardChange(e, index)}
                                    disabled={
                                      !selectCompanyId || isInitialYardId
                                    }
                                  >
                                    <option value="">Select yard</option>
                                    {yard &&
                                      yard[index]?.map((item, id) => (
                                        <option
                                          key={id}
                                          value={item.id}
                                        >{`${item.yard_name}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group">
                                  <label htmlFor="qty">Inspection Quantity</label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={order.inspection_qty}
                                      name="inspection_qty"
                                      onChange={(e) =>
                                        handleQtyChange(e, index)
                                      }
                                      placeholder="Inspection Quantity"
                                    />
                                    <span className="input-group-append ml-2">
                                      <div className="col-md-2">
                                        <button
                                          type="button"
                                          title="Remove"
                                          disabled={
                                            isInitialCompanyId ||
                                            isInitialProductNameId ||
                                            isInitialYardId
                                          }
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() =>
                                            removeOrderNumberRow(index)
                                          }
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })} */}
                      {/* <span className="input-group-append ml-2">
                        <button
                          className="btn btn-primary mt-3"
                          type="button"
                          onClick={addOrderNumberRow}
                        >
                          Add More
                        </button>
                      </span> */}
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePrivateDiNumber;
